import axios from "axios";
import Vue from "vue";
import { Toast } from "vant";
Vue.use(Toast);

// create an axios instance
const service = axios.create({
  baseURL: '/api/', // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 5000, // request timeout
});

service.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    // do something with request error
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response) => {
    const res = response.data;

    if (res.code !== 1) {
      Toast.fail("加载失败");
    } else {
      return res.data;
    }
  },
  (error) => {
    Toast.fail("error.message");
    return Promise.reject(error);
  }
);

export default service
